import React from "react";

export default React.createContext({
    setEvent: () => {},
    setBubbleText: () => {},
    objectPopup: null,
    setObjectPopup: () => {},
    getDatasPopup: null,
    setGetDatasPopup: () => {},
    statePopup: null,
    setStatePopup: () => {},
    subStatePopup: null,
    setSubStatePopup: () => {},
    popupLoadingIcon: null,
    setPopupLoadingIcon: () => {}
});
